<template>
    <div class="order-create-page">
        <div class="order-create-page__container">
            <div class="order-create-page__topbar">
                <el-page-header content="新增订单" @back="$router.push('/todos')" />
                <div class="order-create-page__tip">填写核心信息后即可快速创建订单，后续流程可在详情页继续补充。</div>
            </div>

            <el-card shadow="never" class="order-create-page__card">
                <order-create-form @cancel="$router.push('/todos')" @success="handleCreated" />
            </el-card>
        </div>
    </div>
</template>

<script>
import OrderCreateForm from '../components/OrderCreateForm.vue';

export default {
    name: 'OrderCreate',
    components: {
        OrderCreateForm: OrderCreateForm
    },
    methods: {
        handleCreated(order) {
            this.$message.success('新增订单成功');
            this.$router.replace('/orders/' + order.id);
        }
    }
};
</script>

<style scoped>
.order-create-page {
    padding: 20px 24px 32px;
}

.order-create-page__container {
    max-width: 1080px;
}

.order-create-page__topbar {
    margin-bottom: 16px;
}

.order-create-page__tip {
    margin-top: 10px;
    padding-left: 6px;
    color: #909399;
    font-size: 13px;
}

.order-create-page__card {
    border: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/OrderCreate.vue